import type { Mailbox } from "./api";

const time = new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit" });
const dayMonth = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short" });
const full = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", year: "numeric" });
const long = new Intl.DateTimeFormat("fr-FR", { dateStyle: "full", timeStyle: "short" });

// Date courte pour les listes : l'heure aujourd'hui, le jour cette année, sinon la date complète.
export function shortDate(ms: number): string {
  const d = new Date(ms);
  const now = new Date();
  if (d.toDateString() === now.toDateString()) return time.format(d);
  if (d.getFullYear() === now.getFullYear()) return dayMonth.format(d);
  return full.format(d);
}

export const longDate = (ms: number) => long.format(new Date(ms));

export const who = (m: Mailbox) => m.name || m.address;

export const SYSTEM_NAMES: Record<string, string> = {
  inbox: "Tous les e-mails",
  archive: "Archives",
  trash: "Corbeille",
  spam: "Spam",
  sent: "Envoyés",
  drafts: "Brouillons",
};
